import React from 'react'

import { SxProps } from '@mui/material'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Tooltip from 'components_new/atoms/Tooltip'

import { parseDatetime } from 'utils/dateParser'
import { parseElapsedTimeSince } from 'helpers/Functions/Date'

export interface TimeSinceLabelProps {
  sx?: SxProps
  value: string
}

const TimeSinceLabel = React.forwardRef(
  (props: TimeSinceLabelProps, ref: any) => {
    const { sx, value } = props
    const { t } = useTranslation()

    return (
      <Tooltip title={parseDatetime(value)}>
        <Box
          component="span"
          sx={{
            cursor: 'default',
            textWrap: 'nowrap',
            ['&:hover']: { color: 'text.primary' },
            ...sx
          }}
          ref={ref}
        >
          {t('global', 'time_ago', true, {
            time: parseElapsedTimeSince(value, t)
          })}
        </Box>
      </Tooltip>
    )
  }
)

export default TimeSinceLabel
